import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import cs from 'classnames';


const className = 'line-base-filter';

@inject('lineStore', 'dictStore')
@observer
class PrimaryStatisticalCategories extends Component {
  handleClick = (categoryID) => {
    const { lineStore, gameID } = this.props;
    lineStore.line.selectPrimaryStatisticalCategory(gameID, categoryID);
  };

  render() {
    const { gameID, dictStore: { getLang } } = this.props;
    const primaryCategories = this.props.lineStore.line.statisticalCategories.get(gameID);

    return (
      <div className={className}>
        <div className={`${className}-items`}>
          {primaryCategories.map(({ id, name, isActive, count, isLocaleKey }) => (
            <div
              key={id}
              onClick={() => this.handleClick(id)}
              className={cs(`${className}-item`, { [`${className}-item_active`]: isActive })}
            >
              {isLocaleKey ? getLang(name) : name}
              {!!count && <div className={`${className}-item-count`}>{count}</div>}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default PrimaryStatisticalCategories;



// WEBPACK FOOTER //
// ./src/components/line/additionalCategories/PrimaryStatisticalCategories.jsx